<template>
  <div>
    <div v-if="!showTable">
      <div v-if="data.length === 0 && !loading" class="mt-2">
        Fant ingen {{ $route.meta.headerName.toLowerCase() }}
      </div>

      <CaseCardList
        class="mb-2"
        v-model="data"
        :loading="loadingNewCaseCard"
        :titleKey="titleKey"
        :underRightKey="underRightKey"
        :underLeftKey="underLeftKey"
        :deadlineKey="deadlineKey"
        @click="clickCard"
        @setColor="setColor"
        @fetchData="fetchData"
      >
        <template v-slot:title="{ item }">
          <slot name="title" :item="item"></slot>
        </template>
        <template v-slot:chips="{ item }">
          <slot name="chips" :item="item"></slot>
        </template>
        <template v-slot:underRight="{ item }">
          <slot name="underRight" :item="item"></slot>
        </template>
        <template v-slot:underLeft="{ item }">
          <slot name="underLeft" :item="item"></slot>
        </template>
      </CaseCardList>

      <div v-show="loading && !loadingNewCaseCard" class="text-center mb-2">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
    <div v-else>
      <BaseDataTable
        :items="data"
        :headers.sync="headers"
        :export-name="exportName"
        clickable-row
        :tableId="tableId"
        :loading="loading"
        :serverItemsLength="totalItemCount"
        :totalPages="totalPages"
        :sortBy="sortBy"
        :sortDesc="sortDesc"
        :multi-sort="false"
        :hideRemoveFilterButton="true"
        @rowClicked="clickCard"
        @updateSortBy="$emit('updateSortBy', $event)"
        @newPage="$emit('newPage', $event)"
        @updateItemsPerPage="$emit('updateItemsPerPage', $event)"
      >
        <template v-slot:filter="{ head, item }">
          <slot name="filter" :item="item" :head="head"></slot>
        </template>

        <template v-slot:item="{ item, head }">
          <slot :name="'item'" :item="item" :head="head"></slot>
        </template>
      </BaseDataTable>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import { HeaderObject } from "@/types/tableInterface";

import BaseDataTable from "@/components/shared/table/BaseDataTable.vue";
import CaseCardList from "@/components/shared/cards/CaseCardList.vue";

export default Vue.extend({
  props: {
    headers: {
      type: Array as () => Array<HeaderObject>,
    },
    data: {
      type: Array as () => Array<unknown>,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    titleKey: {
      type: String,
      default: "title",
    },
    deadlineKey: {
      type: String,
      default: "deadline",
    },
    underRightKey: {
      type: String,
      default: "responsible",
    },
    underLeftKey: {
      type: String,
      default: "project",
    },
    totalItemCount: {
      type: Number,
      default: -1,
    },
    totalPages: {},
    tableId: {
      type: String,
      required: true,
    },
    sortBy: {
      type: Array,
      default: () => [],
    },
    sortDesc: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    ...mapActions({
      setTableHeaders: "tables/tableHeaders",
    }),
    setColor(item) {
      this.$emit("setColor", item);
    },
    clickCard(item) {
      this.$emit("click", item);
    },
    fetchData(value = false) {
      this.$emit("fetchData", value);
    },
  },

  computed: {
    ...mapGetters({
      showTable: "tables/showTable",
      tableHeaders: "tables/tableHeaders",
    }),
    loadingNewCaseCard(): boolean {
      return this.loading && this.data.length === 0;
    },
    exportName() {
      return this.$route.meta?.headerName + " tabell";
    },
  },
  components: {
    BaseDataTable,
    CaseCardList,
  },
});
</script>
